import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { WebViewService } from '../services/webview.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private webViewService: WebViewService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => { return event; }),
      catchError((error: HttpErrorResponse) => {        
        // Verificar si es un error 406 (Not Acceptable) - Usuario sin autorización
        if (error.status === 406) {
          // Enviar mensaje a la app nativa de React indicando falta de autorización
          this.webViewService.sendUnauthorized();
        }

        return throwError(() => error);
      })
    );
  }
}
